// 홈 — 연재 중인 작품 목록. 로그인 없이 보인다
import { Link } from 'react-router';

import { usePluginMessages } from '../../../composition/plugin-runtime';
import { useWorksFeed, type SerialApi } from '../composition/use-serial';
import { AiBadge, ErrorText, Loading } from './parts';
import { WhifButton } from './whif/shared/ui/whif-button';

export function feedWidget(api: SerialApi) {
  return function SerialFeedWidget() {
    const t = usePluginMessages('serial');
    const feed = useWorksFeed(api);
    const works = feed.data?.pages.flatMap(p => p.works) ?? [];
    return (
      <section aria-label={t('feed.label')} className="flex flex-col gap-3 py-4">
        <div className="flex items-center justify-between">
          <h2 className="text-title-md">{t('feed.label')}</h2>
          <WhifButton asChild size="sm">
            <Link to="/write">{t('feed.write')}</Link>
          </WhifButton>
        </div>
        {feed.isPending ? <Loading /> : null}
        <ErrorText error={feed.error} />
        {feed.isSuccess && works.length === 0 ? (
          <p className="rounded-global-radius-12 bg-serial-surface px-4 py-12 text-center text-sm text-text-neutral-subtle">{t('feed.empty')}</p>
        ) : null}
        <ul className="flex flex-col gap-2">
          {works.map(w => (
            <li key={w.id}>
              <Link
                to={`/works/${w.id}`}
                className="flex flex-col gap-2 rounded-global-radius-12 bg-serial-surface p-4 transition-colors hover:bg-serial-surface-raised focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-line-outline-brand-primary-focused"
              >
                <div className="flex items-start justify-between gap-3">
                  <span className="text-title-md">{w.title}</span>
                  <AiBadge usage={w.aiUsage} />
                </div>
                {w.synopsis ? <p className="line-clamp-2 text-sm text-text-neutral-subtle">{w.synopsis}</p> : null}
                <p className="text-label-xs-m text-text-neutral-weak">
                  {t('feed.episodes')} {w.episodeCount}
                  {w.mine ? ` · ${t('mine')}` : ''}
                </p>
              </Link>
            </li>
          ))}
        </ul>
        {feed.hasNextPage ? (
          <WhifButton variant="gray" isFullWidth onClick={() => void feed.fetchNextPage()} disabled={feed.isFetchingNextPage}>
            {t('feed.more')}
          </WhifButton>
        ) : null}
      </section>
    );
  };
}
